/** 与后端约定一致的 token 键名 */
const TOKEN_KEY = "token";

/**
 * 读取登录 token：优先 session（本次会话登录），否则 local（记住我）
 */
export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
}

/**
 * @param {string} token
 * @param {boolean} rememberMe  true → localStorage（持久）；false → sessionStorage（关闭标签/浏览器后失效）
 */
export function setToken(token, rememberMe) {
  if (rememberMe) {
    localStorage.setItem(TOKEN_KEY, token);
    sessionStorage.removeItem(TOKEN_KEY);
  } else {
    sessionStorage.setItem(TOKEN_KEY, token);
    localStorage.removeItem(TOKEN_KEY);
  }
  localStorage.setItem("isLogin", "true");
}

/** 清除 token 及登录标记（两处存储都清） */
export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("isLogin");
  localStorage.removeItem("remember");
}

const LOGIN_EMAIL_KEY = "xpz_login_email";

export function saveLoginEmailForRemember(email) {
  const v = (email || "").trim();
  if (v) localStorage.setItem(LOGIN_EMAIL_KEY, v);
}

export function getSavedLoginEmail() {
  return localStorage.getItem(LOGIN_EMAIL_KEY) || "";
}

export function clearSavedLoginEmail() {
  localStorage.removeItem(LOGIN_EMAIL_KEY);
}
